module.exports = __webpack_public_path__ + "img/1.704964e4.jpg";